import { render, staticRenderFns } from "./RoleLine.vue?vue&type=template&id=53d3ce01&lang=pug"
import script from "./RoleLine.vue?vue&type=script&lang=js"
export * from "./RoleLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports